'use client'

/***
 *
 * @file components/ThemeSelector/index.tsx
 * @description ThemeSelector component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

import React, { useEffect } from "react";
// import "./ThemeSelector.scss";

type Props = {
  selectedTheme?: string
}

const ThemeSelector = ({ selectedTheme = "baseplate" }: Props) => {

  const isInContentfulStudio = (typeof window !== "undefined") && window.self !== window.top && window?.document?.getElementsByClassName("styles-module_tooltipWrapper__kqvmR")?.length > 0;

  const isProbablyInEditorMode = isInContentfulStudio;

  useEffect(() => {
    const body: any = window.document.querySelector("body");
    // body?.classList?.add(selectedTheme?.toLowerCase())
    // body?.classList?.remove(body?.className);
    body.className = body?.getAttribute("data-class") + " " + selectedTheme?.toLowerCase();
  }, [selectedTheme]);

  return (
    <div id="ThemeSelector-container" style={{ display: isProbablyInEditorMode ? "block" : "none" }} className="ThemeSelector-container w-screen p-3" data-testid="ThemeSelector">
      {"To select theme select me and change select theme from design tab..."}
    </div>
  );
};

export default ThemeSelector;
